import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App.tsx';
import { CursorGlow } from './components/cursor-glow.tsx';
import { MoltenMetal } from './components/MoltenMetal.tsx';
import { ToastProvider } from './components/toast.tsx';
import { startTitleGlitch } from './lib/title-glitch.ts';
import './styles.css';

const container = document.getElementById('root');
if (container === null) {
  throw new Error('Не найден корневой элемент страницы');
}

startTitleGlitch();

createRoot(container).render(
  <StrictMode>
    <ToastProvider>
      <MoltenMetal />
      <App />
      <CursorGlow />
    </ToastProvider>
  </StrictMode>,
);
